import { useMemo } from 'react';
import { MultiScreenReceiver } from '../controllers/MultiScreenReceiver';
import { MultiScreenClient } from '../communication/MultiScreenClient';

export function useMultiScreenClient(receiver: MultiScreenReceiver | undefined) {
    return useMemo(() => {
        if (!receiver) return;
        return new MultiScreenClient(receiver);
    }, [receiver]);
}
